import * as React from 'react';
import s from '../../ProductLineItemBase.scss';
import {ProductLineItemDataHook} from '../../ProductLineItemBase';
import {classes, st} from './TotalPrice.st.css';
import {getSubscriptionDetailsTranslationKey} from '../../../ProductLineItemsSection/utils';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {useControllerProps} from '../../../../ControllerContext';
import {Item} from '../../../../../../../types/app.types';
import {CompareTotalPrice} from './CompareTotalPrice';

export interface TotalPriceProps {
  lineItem: Item;
  className?: string;
}

export const TotalPrice = ({lineItem, className}: TotalPriceProps) => {
  const {t} = useTranslation();
  const {
    thankYouPageStore: {
      isItemSubtotalDiscountInclusive,
      shouldShowMultipleSubscriptions,
      subscriptionFrequency,
      subscriptionInterval,
      subscriptionBillingCycles,
    },
  } = useControllerProps();

  const formattedTotalPrice = lineItem.lineItemPrice?.formattedAmount;

  const frequency = shouldShowMultipleSubscriptions
    ? lineItem.subscriptionInfo?.subscriptionSettings?.frequency
    : subscriptionFrequency;
  const interval = shouldShowMultipleSubscriptions
    ? lineItem.subscriptionInfo?.subscriptionSettings?.interval
    : subscriptionInterval;
  const billingCycles = shouldShowMultipleSubscriptions
    ? lineItem.subscriptionInfo?.subscriptionSettings?.billingCycles
    : subscriptionBillingCycles;
  const shouldShowFrequency = billingCycles !== 1;
  // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
  const frequencyTranslationKey = getSubscriptionDetailsTranslationKey(interval, frequency);

  return (
    <div className={st(classes.root, className, s.totalPrice)}>
      {isItemSubtotalDiscountInclusive && <CompareTotalPrice lineItem={lineItem} />}
      {formattedTotalPrice && (
        <div data-hook={ProductLineItemDataHook.TotalPrice} className={s.totalPrice}>
          {formattedTotalPrice}
        </div>
      )}
      {shouldShowFrequency && (
        <Text className={classes.frequency} data-hook={ProductLineItemDataHook.TotalPriceFrequency}>
          {
            // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
            t(frequencyTranslationKey, {
              numberOfFrequencyUnits: interval,
            })
          }
        </Text>
      )}
    </div>
  );
};

TotalPrice.displayName = 'ProductLineItem.TotalPrice';
